<template>
  <div id="creator_country_invite" class="invite_page">
    <van-row>
       <van-col span="22" offset="1" class="creator_country_invite_top">
          <img :src="app_logo"/> {{ app_name }}
       </van-col>
      <van-col span="22" offset="1" class="invite_card">
        <van-col span="22" class="creator_country_invite_text">
          <img src="../assets/img/creator/creator_country_invite_text.png"/>
        </van-col>
      
        <van-col span="24" class="invite_card_header">
          <van-col span="10" class="invite_inviter_name">{{ inviter_name }}</van-col>
          <van-col span="4" class="creator_country_invite_avatar">
             <img src="../assets/img/creator/creator_country_invite_frame.png" class="invite_card_frame"/>
            <img :src="head_image" class="invite_avatar"/>
          </van-col>
          <van-col span="8" offset="1" class="invite_inviter_id">ID:{{ inviter_id }}</van-col>
        </van-col>
        <van-col span="24" class="invite_subtitle">Invites You To Be An Agency</van-col>
        <van-col span="24" class="invite_user_id">Your User ID</van-col>
        <van-field v-model="user_id" class="invite_input" placeholder="Enter your User ID"/>
        <van-col span="24" class="invite_user_download">
          No User ID? <span @click="downloadApp">Download</span> and register
        </van-col>
        <van-col span="24">
          <van-col span="16" class="invite_user_id">Baat Verification Code</van-col>
          <van-col span="8" class="invite_user_how_get" @click.native="HowGetCode">How to get?</van-col>
        </van-col>
        <van-col span="24" class="invite_verify_row">
          <van-field
            v-model="verify_code"
            center
            clearable
            class="invite_input"
            placeholder="Enter the code you received"
          >
            <template #button>
              <van-button size="small" round color="#EBEFF3" class="invite_get_btn" @click="getCode">Get</van-button>
            </template>
          </van-field>
        </van-col>
        <van-button block color="linear-gradient(to right, #A529FF,#FF6CF6)" round class="invite_submit_btn" @click="becomeAgencyBtn">Become an Agency</van-button>
      </van-col>

      <van-col span="22" offset="1" class="invite_guide">
        <van-col span="24" class="invite_guide_title">
         How to get Meno's verification code?
        </van-col>
        <van-steps direction="vertical">
          <van-step>
            <template slot="active-icon">
              <!-- 根据不同状态显示不同图标 -->
              <img src="../assets/img/creator/creator_country_invite_dian.png" class="invite_guide_dian"/>
            </template>
            <div class="invite_guide_step">Step 1:Enter your Userand Click [Get] ID</div>
            <p class="invite_guide_step">No User ID? <span @click="downloadApp">Download</span> and register</p>
            <p class="invite_guide_text"> <img src="../assets/img/creator/creator_country_invite_text1.png" /></p>
          </van-step>
          <van-step>
            <template slot="inactive-icon">
              <!-- 根据不同状态显示不同图标 -->
              <img src="../assets/img/creator/creator_country_invite_dian.png" class="invite_guide_dian"/>
            </template>
            <div class="invite_guide_step" id="verify_code_step">Step 2: Open Meno app, Inbox-Meno Team to check verification code</div>
            <p class="invite_guide_text"> <img src="../assets/img/creator/creator_country_invite_text2.png"/></p>
          </van-step>
        </van-steps>
      </van-col>
      <van-col span="24" class="invite_guide_bottom">
        <van-col span="5" class="invite_guide_bottom_img">
          <img :src="app_logo"/>
        </van-col>
        <van-col span="11" class="invite_guide_bottom_name">
          <van-col span="24" class="invite_guide_bottom_name_text">{{ app_name }}</van-col>
          <van-col span="24" class="invite_guide_bottom_name_center">Video & Voice Room</van-col>
        </van-col>
         <van-col span="7" class="invite_guide_bottom_btn">
          <van-button block size="small" color="linear-gradient(to right, #A529FF,#FF6CF6)" round @click="openApp">Open App</van-button>
         </van-col>
      </van-col>
       <van-overlay :show="overlayShow" z-index="3">
        <van-loading type="spinner" class="loading_overlay"/>
      </van-overlay>
    </van-row>
  </div>
</template>

<script>
import '@/assets/css/style.css'
import axios from "axios";
import {Toast} from "vant";
import {judgeIosAndroid} from "../assets/js/models";

export default {
  data() {
    return {
       // 应用配置
      appConfig: {
        openAppTimeout: 2000,  // 超时设置
        appOpenDetectionDelay: 1500,
        returnToPageDelay: 300,
        // 自动打开应用
        autoOpenApp: false
      },
      config: {
        // 应用基本信息
        appName: '',
        packageName: '',
        // 应用协议配置
        scheme: '',
        ios_scheme: '',
        host: '',
        path: '',
        androidDownloadUrl: '', // 下载链接
      },
      inviter_name: '',
      inviter_id: '',
      head_image:'',
      user_id: '',
      verify_code: '',
      invitation_code: '',
      app_name: '',
      app_logo: '',
      download: '',
      bg: require('../assets/img/creator/creator_country_invite_bg.png')
    }
  },
  created() {
    this.getConfig()
    this.invitation_code = this.$route.query.invitation_code
    this.convert()
  },
  methods: {
    HowGetCode() {
      const element = document.getElementById("verify_code_step")
      if (element) {
        // 带平滑效果
        element.scrollIntoView({ 
          behavior: 'smooth',
          block: 'start' // 对齐到顶部
        })
      }
    },
    convert() {
      this.overlayShow = true
      axios.get(this.baseUrlApi + this.baseUrlPath + "?ctl=creator_country&act=get_invite_agency_data", {
        params : {
          invite_code: this.invitation_code
        }
      }).then(res =>{
        this.overlayShow = false
        if (res.data.status === 0) {
          Toast(res.data.error)
          return false
        }
        this.inviter_name = res.data.data.nick_name
        this.head_image = res.data.data.head_image
        this.inviter_id = res.data.data.user_id
        this.app_name = res.data.data.app_name
        this.app_logo = res.data.data.app_logo
        this.download = res.data.data.download
      })
    },
    getCode() {
      this.overlayShow = true
      axios.get(this.baseUrlApi + this.baseUrlPath + "?ctl=creator_country&act=get_verify_code", {
        params : {
          to_user_id: this.user_id,
          invite_code: this.invitation_code
        }
      }).then(res =>{
        this.overlayShow = false
        Toast(res.data.error)
      })
    },
    becomeAgencyBtn() {
      this.overlayShow = true
      axios.get(this.baseUrlApi + this.baseUrlPath + "?ctl=creator_country&act=become_an_agency", {
        params : {
          to_user_id: this.user_id,
          invite_code: this.invitation_code,
          verify_code: this.verify_code
        }
      }).then(res =>{
        this.overlayShow = false
        Toast(res.data.error)
        if (res.data.status == 1) {
          this.$router.push({ path: '/creator_country_invite_success' })
        }
      })
    },
    downloadApp() {
       this.$router.push({ path: '/download' });
    },
     getConfig() {
      axios.get(this.baseUrlApi + this.baseUrlPath + "?ctl=user_h5&act=share_config").then(res =>{
        this.config = res.data.data
      })
    },
    openApp() {
      const isIos = judgeIosAndroid();
      let scheme = this.config.scheme
      if (isIos === true) {
        // ios
        scheme = this.config.ios_scheme
      }
      // 构建拉起App的URL
      const appUrl = scheme + `://${this.config.host}${this.config.path}`;
      // 尝试打开App
      window.location.href = appUrl;
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/creator_country_invite.vue